/* unplugin-vue-components disabled */import script from "./device-detail.vue?vue&type=script&s=true&setup=true&lang=js"
export * from "./device-detail.vue?vue&type=script&s=true&setup=true&lang=js"

import "./css/device-detail.scss?vue&type=style&index=0&id=91ffe03e&scoped=true&lang=scss"

import exportComponent from "/Users/chenhaichao/代码/official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91ffe03e"]])

export default __exports__